module.exports = __webpack_public_path__ + "img/icon-onboarding-shopping-cart.530f47af.svg";